/** MCP 域接口（与 apps/server/src/routes/mcp.ts 一一对应） */
import type { VoiceStatus } from '@znjj/shared';
import { apiGet, apiJson } from './client';

export interface McpSettings {
  /** 形如 http://host:3000/<token>，填进小智 / NAS 的 mcp_server_settings */
  endpointUrl: string;
  token: string;
  createdAt: string;
}

export interface McpTool {
  name: string;
  description: string;
  inputSchema: unknown;
}

export interface McpCallLog {
  id: number;
  toolName: string;
  args: unknown;
  result: unknown;
  ok: boolean;
  durationMs: number | null;
  /** http = 自建接入地址调用；xiaozhi = 小智官方语音调用 */
  source: string;
  createdAt: string;
}

export interface VoiceBinding {
  url: string | null;
  status: VoiceStatus;
  connectedAt: string | null;
  disconnectedAt: string | null;
  callCount: number;
  lastCallAt: string | null;
  lastError: string | null;
}

export const mcpApi = {
  settings: (): Promise<{ settings: McpSettings }> => apiGet<{ settings: McpSettings }>('/api/mcp/settings'),

  /** 轮换接入地址：旧地址立即失效 */
  rotate: (): Promise<{ settings: McpSettings }> => apiJson<{ settings: McpSettings }>('POST', '/api/mcp/settings'),

  tools: (): Promise<{ list: McpTool[] }> => apiGet<{ list: McpTool[] }>('/api/mcp/tools'),

  logs: (limit = 50): Promise<{ list: McpCallLog[]; limit: number }> =>
    apiGet<{ list: McpCallLog[]; limit: number }>(`/api/mcp/logs?limit=${limit}`),

  voiceBinding: (): Promise<{ binding: VoiceBinding }> => apiGet<{ binding: VoiceBinding }>('/api/mcp/voice-binding'),

  saveVoiceUrl: (url: string): Promise<{ binding: VoiceBinding }> =>
    apiJson<{ binding: VoiceBinding }>('PUT', '/api/mcp/voice-binding', { url }),

  connectVoice: (url?: string): Promise<{ binding: VoiceBinding }> =>
    apiJson<{ binding: VoiceBinding }>('POST', '/api/mcp/voice-binding/connect', url ? { url } : undefined),

  disconnectVoice: (): Promise<{ binding: VoiceBinding }> =>
    apiJson<{ binding: VoiceBinding }>('POST', '/api/mcp/voice-binding/disconnect'),
};

export const mcpKeys = {
  settings: ['mcp', 'settings'] as const,
  tools: ['mcp', 'tools'] as const,
  logs: ['mcp', 'logs'] as const,
  voice: ['mcp', 'voice'] as const,
};
